// extracted by mini-css-extract-plugin
export default {"navLink":"tab-menu_navLink__RSkRJ","active":"tab-menu_active__9XiqR"};